import { StreamEl, TimeLabel } from '@mi-front/ui';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { useFocus } from '../../stores/stream-screen.store';

export const PreviewFocusMarkers = () => {
  const tz = useTimezone();
  const focus = useFocus();

  return (
    <>
      {focus.from && (
        <StreamEl anchor="right" offsetX={16} ts={focus.from} position="center">
          <TimeLabel ts={focus.from} tz={tz} />
        </StreamEl>
      )}
      {focus.to && (
        <StreamEl offsetX={16} ts={focus.to} position="center">
          <TimeLabel ts={focus.to} tz={tz} />
        </StreamEl>
      )}
    </>
  );
};
